import _isNull from 'lodash/isNull';

const cvDomainOperation = () => {
  // will be removed after we use long domain
  try {
    if (window.location.hostname.indexOf("citivelocity") >= 0) {
      document.domain = window.location.hostname;
      return;
    }
    const t = parent.document;
    const d: any = _isNull(document.domain.match(/[a-zA-Z0-9-]+\.[a-zA-Z]{2,4}$/)) ? '' : document.domain.match(/[a-zA-Z0-9-]+\.[a-zA-Z]{2,4}$/);
    if (!t) {
      document.domain = d;
    }
  } catch (e) {
    document.domain = String(_isNull(document.domain?.match(/[a-zA-Z0-9-]+\.[a-zA-Z]{2,4}$/)) ? '' : document.domain?.match(/[a-zA-Z0-9-]+\.[a-zA-Z]{2,4}$/));
    console.error(e);
  }
};

export default cvDomainOperation;
